import { SideModal } from "shared";
import { CompanyMyType } from "types/CompanyTypes";
import "./TransactionsSideModal.scss";
import TransactionsTable from "./components/TransactionsTable";
import { useGetMe } from "hooks/auth";
import { SharesByCompanyType } from "types/SharesTypes";
import { Button } from "shared";
import { isDesktop } from "utils";

interface TransactionsSideModalProps {
  isOpen: boolean;
  onClose: () => void;
  company: CompanyMyType | null;
  setEditTransaction: (company: SharesByCompanyType) => void;
  onAddTransactionClick: () => void;
}

const TransactionsSideModal: React.FC<TransactionsSideModalProps> = ({
  isOpen,
  onClose,
  company,
  setEditTransaction,
  onAddTransactionClick,
}) => {
  const client =
    company && company.shares && company.shares[0] && company?.shares[0]?.user;
  const { data: authorizedUser } = useGetMe();
  const isAdmin = authorizedUser?.role === "admin";
  return (
    <SideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Lista transakcji"
      subtitle={
        isAdmin ? (
          <p>
            <b>Spółka:</b> {company?.name || "-"} | <b>Klient:</b>{" "}
            {client?.name || "-"}
          </p>
        ) : (
          <p>
            <b>Spółka:</b> {company?.name || "-"}{" "}
          </p>
        )
      }
      className="company-info-modal wide"
    >
      <>
        <Button
          className="button--rounded company-info-modal__button"
          onClick={onAddTransactionClick}
          label="Dodaj transakcję  +"
          styleType={isDesktop() ? undefined : "primary"}
        />
        <TransactionsTable
          isAdmin={isAdmin}
          company={company}
          setEditTransaction={setEditTransaction}
        />
      </>
    </SideModal>
  );
};

export default TransactionsSideModal;
